import React from 'react';
import classNames from 'classnames';
import axios from 'lib/axios';

const PageLink = ({ active, label, url, setData, payload }) => {
  const className = classNames(
    [
      'mr-1 mb-1',
      'px-4 py-3',
      'border border-solid border-gray-300 rounded',
      'text-sm',
      'hover:bg-white',
      'hover:text-pblue',
      'focus:outline-none focus:border-indigo-700 focus:text-indigo-700'
    ],
    {
      'bg-pblue text-white': active
    }
  );

  const handleClick = async (url) => {

    if(url.includes('filters')){
      var response = await axios.post(url, payload);
    }else{
      var response = await axios.get(url);
    }
    const { data } = response.data;
    setData(data);
    console.log(" new resp", data);
  }

  return (
    <button className={className} onClick={()=>handleClick(url, payload)}>
      <span dangerouslySetInnerHTML={{ __html: label }}></span>
    </button>
  );
};

// Previous, if on first page
// Next, if on last page
// and dots, if exists (...)
const PageInactive = ({ label }) => {
  const className = classNames(
    'mr-1 mb-1 px-4 py-3 text-sm border rounded border-solid border-gray-300 text-gray'
  );
  return (
    <div className={className} dangerouslySetInnerHTML={{ __html: label }} />
  );
};

export default ({ links = [], setData, payload }) => {
  // dont render, if there's only 1 page (previous, 1, next)
  if (links.length === 3) return null;
  return (
    <div className="flex flex-wrap mt-6 -mb-1 bg-white m-4 p-2">
      {links.map(({ active, label, url }) => {
        return url === null ? (
          <PageInactive key={label} label={label} />
        ) : (
          <PageLink 
            key={label} 
            label={label} 
            active={active} 
            url={url} 
            setData={setData} 
            payload={payload} 
          />
        );
      })}
    </div>
  );
};
